<template>
  <v-card class="mb-4" outlined>
    <v-card-title class="section-header" v-if="!wideLayout">
      <v-icon left color="grey darken-1">mdi-speedometer</v-icon>
      {{ $t("limits") }}
    </v-card-title>

    <v-tabs
      v-model="activeTab"
      background-color="transparent"
      grow
      class="tabs-normal-case"
    >
      <v-tab>
        <v-icon left small>mdi-cog-outline</v-icon>
        {{ $t("general_settings") }}
      </v-tab>
      <v-tab>
        <v-icon left small>mdi-credit-card-outline</v-icon>
        {{ $t("payment_and_credits") }}
      </v-tab>
      <v-tab>
        <v-icon left small>mdi-file-document-edit-outline</v-icon>
        {{ $t("additional_rules") }}
      </v-tab>
    </v-tabs>

    <v-divider></v-divider>

    <v-card-text class="pt-4">
      <v-tabs-items v-model="activeTab">
        <v-tab-item>
          <general-settings-tab
            :restaurant="restaurant"
            :company="company"
            :value="value"
            :localCanOrderExtra="localCanOrderExtra"
            :wide-layout="wideLayout"
            @save="emitSave"
            @update-voucher="handleVoucherUpdate"
          />
        </v-tab-item>
        <v-tab-item>
          <payment-credits-tab :wide-layout="wideLayout" @save="emitSave" />
        </v-tab-item>
        <v-tab-item>
          <additional-rules-tab :wide-layout="wideLayout" @save="emitSave" />
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
  </v-card>
</template>

<script>
import GeneralSettingsTab from "./tabs/GeneralSettingsTab.vue";
import PaymentCreditsTab from "./tabs/PaymentCreditsTab.vue";
import AdditionalRulesTab from "./tabs/AdditionalRulesTab.vue";

export default {
  name: "LimitsCard",
  components: {
    GeneralSettingsTab,
    PaymentCreditsTab,
    AdditionalRulesTab,
  },
  props: {
    value: {
      type: String,
      default: null,
    },
    restaurant: {
      type: Object,
      default: null,
    },
    company: {
      type: Object,
      default: null,
    },
    price: {
      type: [String, Number],
      default: 0,
    },
    canOrderExtra: {
      type: Boolean,
      default: false,
    },
    wideLayout: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 0,
      localPrice: this.price,
      localCanOrderExtra: this.canOrderExtra,
    };
  },
  watch: {
    price(val) {
      this.localPrice = val;
    },
    canOrderExtra(val) {
      this.localCanOrderExtra = val;
    },
  },
  methods: {
    emitSave() {
      this.$emit("save");
    },
    handleVoucherUpdate(data) {
      if (this.restaurant) {
        this.restaurant.voucher = data;
      }
    },
  },
};
</script>

<style scoped>
.section-header {
  font-size: 0.95rem;
  font-weight: 500;
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #eee;
}

.subtitle-text {
  font-size: 0.95rem;
  font-weight: 500;
  color: #424242;
}

.limit-option-card {
  transition: all 0.2s ease;
}

.limit-option-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.option-description {
  font-size: 0.813rem;
  color: #757575;
  line-height: 1.4;
}

.tabs-normal-case >>> .v-tab {
  text-transform: none !important;
}
</style>

<style>
/* Radio button alignment - unscoped for Vuetify components */
.limits-card .v-radio {
  align-items: center !important;
}

.limits-card .v-radio .v-input--selection-controls__input {
  align-self: center !important;
  margin-top: 0 !important;
}

.limits-card .v-radio .v-label {
  display: flex;
  align-items: center !important;
}
</style>
